import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "form-group form-check custom-checkbox" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "payable"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("i", null, " No Actions ")
], -1 /* HOISTED */)
const _hoisted_6 = {
  key: 1,
  class: "button-cell text-end"
}
const _hoisted_7 = {
  key: 2,
  class: "button-cell text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isAddRequested ? 'edit-row' : ''}`)
  }, [
    _createElementVNode("td", {
      colspan: `${_ctx.isEditRequested || _ctx.isAddRequested ? '2' : '1'}`,
      class: "align-top"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("input", {
          type: "checkbox",
          id: "payable",
          class: "form-check-input",
          checked: _ctx.detail.isBillable,
          disabled: ""
        }, null, 8 /* PROPS */, _hoisted_3),
        _hoisted_4
      ])
    ], 8 /* PROPS */, _hoisted_1),
    (!_ctx.isEditRequested && !_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("td", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.detail.payerName
            }, null, 8 /* PROPS */, ["text"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.formatDate(_ctx.detail.visitStartTime)
            }, null, 8 /* PROPS */, ["text"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.formatTime(_ctx.detail.visitStartTime)
            }, null, 8 /* PROPS */, ["text"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.formatDate(_ctx.detail.visitEndTime)
            }, null, 8 /* PROPS */, ["text"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.formatTime(_ctx.detail.visitEndTime)
            }, null, 8 /* PROPS */, ["text"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_EmptyTextHandler, {
              text: _ctx.detail.isBilled ? 'Yes' : 'No'
            }, null, 8 /* PROPS */, ["text"])
          ]),
          _hoisted_5
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveEditDetail()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelEditDetail()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-success",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
          }, "Add"),
          _createElementVNode("button", {
            type: "button",
            class: "btn table-btn btn-outline-secondary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelSaveNewDetail()))
          }, " Cancel ")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}